// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// D21 · TODO O GESTO QUE FALA COM A REDE DIZ O QUE ACONTECEU
// ============================================================================
//
// 📗 Achado de 2026-09-08, em dois ecrãs: `CaixaDeEntrada.abrir` fazia `if (!r.ok) return;`
//    **sem `catch`**, e as quatro escritas do `CaixasDeEmail` tinham `try/finally` e **nenhum
//    `catch`**. Numa falha de rede a promessa rejeita, o `finally` corre (o botão desbloqueia)
//    e **não se escreve erro nenhum**: o ecrã fica exactamente como estava antes do clique.
//
// 📌 É «uma recusa que não se vê» — clicar e não acontecer nada lê-se como botão avariado, e
//    manda a pessoa clicar outra vez em vez de pedir acesso ou tentar mais tarde.
//
// ⚠️⚠️ **A REGRA NÃO NASCEU AQUI — foi EXTRAÍDA.** O `carregar` do `CaixaDeEntrada` já a tinha
//    inteira, com a razão escrita: *«403 e NÃO `!r.ok` em bloco: um 403 e um 500 mandam a
//    pessoa a sítios diferentes — "peça acesso" não é "tente outra vez"»*, e *«falha de rede: o
//    mesmo sítio do 500»*. 📌 O que este módulo faz é dar-lhe **um** corpo, para a segunda
//    formulação deixar de poder nascer.
//
// ⚠️ **A FALHA DE REDE NÃO TEM ESTADO PRÓPRIO nas leituras — vai com o 500**, e a decisão é a
//    que já estava tomada: as duas resolvem-se com o mesmo gesto («tente outra vez»). Nas
//    ESCRITAS é diferente e por uma razão de conteúdo: num `!ok` o servidor manda a frase (só
//    ele sabe se foi um duplicado, um plano-cópia ou um endereço sem «@»), e quando nem se chega
//    ao servidor **não há frase nenhuma para mostrar** — daí `FALHA_DE_REDE`.
//
// ⚠️ **O que TEM estado próprio é o pedido ABORTADO** (`abortada`), e não por simetria: um
//    cancelamento não é uma falha e não se escreve nada. Ver a nota do tipo.
//
// ⚠️⚠️ **MEDIDO ANTES DE ESCREVER ISTO, e é maior do que os dois ecrãs** (2026-09-08, varredura
//    por indentação sobre `apps/web/src`): **66 das 121 chamadas a `fetch`** sem um `try`/`catch`
//    a envolvê-las. 📌 Este módulo cobriu primeiro as **5** reportadas; as outras **61** ficaram
//    contadas e não escondidas, com tecto no `todo-gesto-de-rede-fala.test.ts`.
//
// ---------------------------------------------------------------------------
// ✅ E DEPOIS PASSOU A COBRIR TUDO — 61 → 0 (2026-09-08, mais tarde no mesmo dia)
// ---------------------------------------------------------------------------
//
// ⚠️⚠️ **Metade daquele 61 nunca existiu:** o detector do guarda só conhecia `try { … } catch`,
//    e **39** chamadas tratavam o erro por `.catch()` na cadeia da promessa. As realmente por
//    tratar eram **21**, quase todas `await fetch(…POST…)` sem `catch` nenhum — a classe exacta
//    do defeito reportado. Estão todas aqui agora, em 13 ficheiros.
//
// ⚠️⚠️ **E CONVERTÊ-LAS OBRIGOU A ALARGAR ESTE MÓDULO EM QUATRO PONTOS — sem eles a extracção
//    APAGAVA lógica de negócio**, que é o pior resultado possível de uma extracção:
//
//      · `EscritaNaRede.recusa.corpo` — o `PorConfirmar` trata `ja_efectivado` como sucesso (é a
//        guarda contra avisar o motorista duas vezes) e a Gestão trata `nome_duplicado` como uma
//        pergunta e não um erro. **Decidem pelo CÓDIGO, não pelo texto**; sem o corpo, casar a
//        frase punha o comportamento à mercê da redacção da mensagem.
//      · `EscritaNaRede.recusa.estado` — o `PartirViagem`, o `CancelarServico` e o `MoverBloco`
//        passam o par (corpo, estado) ao travão de J-0. E `estado: null` — «não se chegou ao
//        servidor» — é o que impede o travão de oferecer **«forçar»** sobre uma falha de rede:
//        propor repetir com uma bandeira que ninguém recusou.
//      · `LeituraDaRede.erro.frase` — a Gestão mostra o texto do servidor, e *«"consumo
//        (l/100 km)" tem de ser um número (recebi "29,0 l")»* diz **qual o campo**. Um «tente
//        outra vez» nosso escondia-o.
//      · `LeituraDaRede.abortada` — um pedido cancelado **não é uma falha**, e tem estado
//        próprio para o compilador obrigar a distingui-lo (ver a nota lá).
//
// ⚠️ **`seFaltar` passou a OPCIONAL**, com a omissão a citar o código de estado — era
//    literalmente a frase que dez destes ecrãs já tinham à mão, e sem ela cada conversão perdia
//    a única pista que distingue um 403 de um 409 de um 500 quando o servidor não manda texto.
// ============================================================================

import { useCallback, useRef } from 'react';

/**
 * A frase de quando **não se chegou ao servidor** — e não uma recusa dele.
 *
 * ⚠️ Distinta de propósito de qualquer frase de recusa: uma recusa tem explicação e um caminho
 * («o endereço já existe», «desactive em vez de apagar»); isto não tem nenhuma, e o que a
 * pessoa pode fazer é outra coisa — ver a ligação e repetir.
 */
export const FALHA_DE_REDE =
  'Não foi possível falar com o servidor. Verifique a ligação e tente outra vez.';

/**
 * O resultado de uma LEITURA.
 *
 * 📌 Os três primeiros são os que o `CaixaDeEntrada` já distinguia; o `abortada` entrou quando
 * o módulo passou a aceitar um `AbortSignal` (ver o cabeçalho, 61 → 0).
 */
export type LeituraDaRede<T> =
  | { readonly tipo: 'ok'; readonly corpo: T }
  | { readonly tipo: 'sem-acesso' }
  /**
   * O pedido foi CANCELADO por quem o fez — a janela fechou, o mapa recarregou.
   *
   * ⚠️ **Não é uma falha e não se escreve nada**: só acontece a quem passa um `AbortSignal`.
   */
  | { readonly tipo: 'abortada' }
  | {
      readonly tipo: 'erro';
      /**
       * ⚠️ A frase do SERVIDOR quando ele mandou uma, ou a da rede quando não se chegou lá.
       *
       * 📌 Existe porque os ecrãs de Gestão mostram o texto da recusa — *«"consumo (l/100 km)"
       * tem de ser um número (recebi "29,0 l")»* diz o que corrigir, e um «tente outra vez»
       * nosso escondia o campo. ⚠️ **Sem este campo, converter esses ecrãs para a formulação
       * partilhada apagava-lhes a mensagem** — e a alternativa era uma SEGUNDA formulação de
       * leitura, que é exactamente o que este módulo existe para impedir.
       */
      readonly frase: string;
      /** `null` quando não se chegou ao servidor — não há código nenhum a citar. */
      readonly estado: number | null;
    };

/**
 * Lê uma rota e classifica o que aconteceu — nunca deixa a promessa rejeitar.
 *
 * ⚠️ O `403` sai à parte porque manda a pessoa a outro sítio (pedir acesso). Tudo o resto —
 * 500, 503 sem base, rede em baixo — é «tente outra vez», que é a decisão que o `carregar`
 * deste ecrã já tinha tomado e explicado.
 */
export async function lerDaRede<T>(url: string, sinal?: AbortSignal): Promise<LeituraDaRede<T>> {
  try {
    const r = await fetch(url, sinal === undefined ? undefined : { signal: sinal });
    if (r.status === 403) return { tipo: 'sem-acesso' };
    if (!r.ok) {
      const c = (await r.json().catch(() => null)) as
        | { detalhe?: string; erro?: string }
        | null;
      return {
        tipo: 'erro',
        frase: c?.detalhe ?? c?.erro ?? `o servidor respondeu ${String(r.status)}`,
        estado: r.status,
      };
    }
    return { tipo: 'ok', corpo: (await r.json()) as T };
  } catch (e) {
    // ⚠️⚠️ **UM PEDIDO ABORTADO NÃO É UMA FALHA**, e tem estado PRÓPRIO em vez de se disfarçar
    //    de erro. 📌 Sem isto, cada desmontagem de janela e cada recarga do mapa escreviam «não
    //    foi possível falar com o servidor» num ecrã que ia desaparecer — é o ramo que o
    //    `Kpis.tsx` já tinha à mão («marcá-lo como falha fazia a barra dizer "sem medição" a
    //    cada recarga»), e que passa a viver aqui uma vez só.
    // ⚠️ **Estado próprio e não `erro` com `estado: null`:** com os dois no mesmo ramo, quem
    //    lesse a `frase` mostrava-a — e a única defesa era cada chamador lembrar-se de
    //    verificar `sinal.aborted`. Um `tipo` que o compilador obriga a distinguir não se
    //    esquece.
    if (e instanceof DOMException && e.name === 'AbortError') return { tipo: 'abortada' };
    return { tipo: 'erro', frase: FALHA_DE_REDE, estado: null };
  }
}

/**
 * O resultado de uma ESCRITA: correu, ou não correu **e há uma frase para mostrar**.
 *
 * ⚠️ O `estado` distingue as duas maneiras de não correr, e existe porque vários ecrãs já
 * diziam «o servidor respondeu 409» quando ele não mandava frase — informação de diagnóstico
 * que se perderia ao passar por aqui. 📌 `null` significa que **não se chegou ao servidor**,
 * logo não há código nenhum a citar; é o caso da `FALHA_DE_REDE`.
 */
export type EscritaNaRede<T> =
  | { readonly tipo: 'ok'; readonly corpo: T | null }
  | {
      readonly tipo: 'recusa';
      readonly frase: string;
      readonly estado: number | null;
      /**
       * ⚠️⚠️ O corpo da RECUSA, e não só a frase — `null` quando não se chegou ao servidor.
       *
       * 📌 Existe porque vários gestos decidem pelo **código** de erro e não pelo texto: o
       * `PorConfirmar` trata `ja_efectivado` como sucesso (é a guarda contra avisar o
       * motorista duas vezes, e pintá-la de vermelho ensinava a desconfiar dela), e o
       * `PartirViagem` passa o corpo inteiro ao travão de J-0. Sem isto, converter estes
       * ecrãs para a formulação partilhada **apagava-lhes lógica de negócio** — o pior
       * resultado possível de uma extracção.
       */
      readonly corpo: T | null;
    };

/**
 * Faz um `POST` com corpo JSON e devolve **sempre** algo que se pode mostrar.
 *
 * ⚠️⚠️ **A frase de uma recusa é a do SERVIDOR e não uma minha** — é ele que sabe se foi um
 * duplicado, um plano-cópia ou um endereço sem «@», e cada uma manda corrigir coisa diferente.
 * O `seFaltar` é só a rede de segurança para uma resposta sem corpo.
 *
 * ⚠️ O corpo vem como `T | null`: um `204` ou um JSON malformado não é motivo para rebentar o
 * gesto, e quem chama já sabe ler campos opcionais.
 *
 * ⚠️⚠️ **O `seFaltar` é OPCIONAL, e a omissão cita o código de estado** («o servidor respondeu
 * 409»). 📌 Não é preguiça: era **literalmente** a frase que dez destes ecrãs já tinham escrita
 * à mão, e sem ela cada conversão para esta formulação **perdia** o código — a única pista que
 * distingue um 403 de um 409 de um 500 quando o servidor não manda texto. Passa-se uma frase
 * própria só quando o ecrã sabe dizer melhor.
 */
export async function escreverNaRede<T>(
  url: string,
  corpo: unknown,
  seFaltar?: string,
  // 2026-10-28 · a página «Formação» grava as marcas por `PUT` (`/api/formacao/marca`). O verbo
  //    passa a parâmetro para ela usar ESTA formulação em vez de escrever uma segunda à mão; a
  //    omissão é `POST`, logo nenhum chamador existente muda.
  metodo: 'POST' | 'PUT' = 'POST',
): Promise<EscritaNaRede<T>> {
  try {
    const r = await fetch(url, {
      method: metodo,
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(corpo),
    });
    const c = (await r.json().catch(() => null)) as
      | (T & { detalhe?: string; erro?: string })
      | null;
    if (!r.ok) {
      const semFrase = seFaltar ?? `o servidor respondeu ${String(r.status)}`;
      return {
        tipo: 'recusa',
        frase: c?.detalhe ?? c?.erro ?? semFrase,
        estado: r.status,
        corpo: c,
      };
    }
    return { tipo: 'ok', corpo: c };
  } catch {
    return { tipo: 'recusa', frase: FALHA_DE_REDE, estado: null, corpo: null };
  }
}

// ============================================================================
// UMA LEITURA QUE FALHA DIZ QUE FALHOU — e não se lê como «lista vazia» (2026-10-21)
// ============================================================================
//
// 🔴 Achado de revisão: o `DiasDoItinerario` (Gestão) fazia `r.ok ? r.json() : null` e depois
//    `c?.paragens ?? []` — um 403 ou um 500 lia-se como «itinerário sem dias», e o «Gravar
//    dias» seguinte enviava a lista vazia a uma rota que faz DELETE + reinserção: **apagava os
//    dias reais de um itinerário partilhado**. A mesma forma vivia no `NovoPedido`, no
//    `CriarItinerario` e no `RegrasNegocio` (a lista das divergências por ratificar
//    desaparecia em silêncio).
//
// 📌 A regra: uma leitura que falha **diz que falhou**, e o ecrã **não deixa gravar** como se
//    a lista estivesse vazia. A frase sai daqui, uma vez, para os ecrãs não escreverem cada um
//    a sua — e o guarda `leitura-falhada-nao-e-vazio.test.ts` recusa a forma antiga.

/**
 * A frase a mostrar quando a leitura de `oQue` não chegou — ou `null` se chegou (ou foi
 * cancelada, que não é falha).
 *
 * ⚠️ O 403 diz «sem acesso» e não «tente outra vez», pela mesma razão do `lerDaRede`.
 */
export function fraseDaLeituraFalhada(r: LeituraDaRede<unknown>, oQue: string): string | null {
  if (r.tipo === 'ok' || r.tipo === 'abortada') return null;
  if (r.tipo === 'sem-acesso') return `não tem acesso para ler ${oQue}`;
  return `não foi possível ler ${oQue} (${r.frase})`;
}

// ============================================================================
// SÓ A ÚLTIMA RESPOSTA ESCREVE (2026-10-22)
// ============================================================================
//
// 🔴 Achado da revisão de 2026-10-21: a Gestão (trocar de separador) e o Diário (mudar de filtro)
//    escreviam sempre a resposta que chegava — e uma resposta ANTIGA que chegasse depois da nova
//    tapava-a. Na Gestão, as linhas de Viaturas podiam aparecer com os campos de Motoristas.
// 📌 Cada leitura pede uma vez «é a minha a mais recente?» antes de escrever; uma ultrapassada cala-se.

/**
 * Devolve `comecar()`: chama-se no início de cada leitura, e devolve `aindaEAUltima()` para chamar
 * depois do `await`, antes de escrever no estado.
 */
export function useSoAUltimaResposta(): () => () => boolean {
  const contador = useRef(0);
  return useCallback(() => {
    const minha = ++contador.current;
    return () => minha === contador.current;
  }, []);
}
